import './icon.css'
import './web_component'
import React from 'react'
import { IconLayoutProps } from './types'

export const Icon: React.FC<IconLayoutProps> = ({ children, ...props }) => <icon-l {...props}>{children}</icon-l>
